import { IAgencyGridRow } from '@/Interfaces/Agency.interface';
import ExportIcon from '@/components/Icons/ExportIcon';
import { useAppDispatch } from '@/store/hooks';
import { setSelectedAgency } from '@/store/slices/agencies.slice';
import { Button, styled } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { useCallback } from 'react';

const ViewAgencyButton = styled(Button)(({ theme }) => ({
  minHeight: '29px',
  paddingTop: 0,
  paddingBottom: 0,
  borderRadius: theme.shape.borderRadius * 4,
  textWrap: 'nowrap',
  maxWidth: '200px',
  '& .MuiButton-startIcon': {
    marginRight: theme.spacing(1),
  },
  '& .MuiButton-label': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

const ActionsCell = ({ row }: GridRenderCellParams<IAgencyGridRow>) => {
  const dispatch = useAppDispatch();

  const selectRow = useCallback(() => {
    if (!row) return;
    dispatch(setSelectedAgency(row));
  }, [dispatch, row]);

  return (
    <div className='flex justify-center'>
      <ViewAgencyButton
        startIcon={<ExportIcon className='w-[11px]' />}
        variant='outlined'
        color='primary'
        onClick={selectRow}
        aria-label={`View details for ${row?.name || 'agency'}`}
      >
        View
      </ViewAgencyButton>
    </div>
  );
};

export default ActionsCell;
